var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon
    ? _c(
        "div",
        {
          staticClass:
            "text-left display-flex flex-row flex-wrap tablet:flex-nowrap flex-items-center margin-bottom-lg tablet:margin-bottom-0",
          staticStyle: {
            gap: "var(--spacing-md)",
            "--link-color": "var(--fa-navy)",
            "--button-margin-bottom": "0",
            "--button-padding": "0",
          },
        },
        [
          _c("h1", { staticClass: "sr-only" }, [
            _vm._v(
              "Viewing Details for the " +
                _vm._s(_vm.styling.style) +
                " style of " +
                _vm._s(_vm.icon.name)
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "link size-2xl flat copy-button text-nowrap",
              staticStyle: {
                "--button-color": "var(--fa-navy)",
                "font-weight": "var(--font-weight-bold)",
                "--button-hover-color": "var(--fa-dk-blue)",
              },
              attrs: {
                "data-balloon-pos": "up",
                "aria-label":
                  _vm.justCopied === "iconId" ? "Copied" : "Copy Icon Name",
              },
              on: { click: _vm.copyId },
            },
            [
              _c("span", { staticClass: "sr-only" }, [_vm._v("Copy")]),
              _vm._v("\n    " + _vm._s(_vm.icon.name) + "\n  "),
            ]
          ),
          _vm._v(" "),
          _vm.isProIcon
            ? [
                !_vm.isProUser
                  ? _c(
                      "span",
                      {
                        staticClass: "tag rounded",
                        staticStyle: { "--tag-background": "var(--fa-yellow)" },
                        attrs: {
                          "aria-label": "This is a Pro Icon",
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.clickedProTag()
                          },
                        },
                      },
                      [_vm._v("\n      Pro\n    ")]
                    )
                  : _c(
                      "span",
                      {
                        staticClass: "tag rounded",
                        staticStyle: { "--tag-background": "var(--fa-gravy)" },
                        attrs: {
                          "aria-label": "This is a Pro Icon",
                          "data-balloon-pos": "up",
                        },
                      },
                      [_vm._v("\n      Pro\n    ")]
                    ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowingLink
            ? _c(
                "button",
                {
                  staticClass: "link flat copy-button",
                  staticStyle: {
                    "--button-color": "var(--fa-gravy)",
                    "--button-hover-color": "var(--fa-dk-blue)",
                  },
                  attrs: {
                    "data-balloon-pos": "up",
                    "aria-label":
                      _vm.justCopied === "iconUrl" ? "Copied" : "Copy Icon URL",
                  },
                  on: { click: _vm.copyUrl },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.solid.faLinkSimple, size: "xl" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Copy " + _vm._s(_vm.icon.name) + " URL's"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }